// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4kOja","toggle":"styles_toggle__3Nv6B","preview":"styles_preview__ocwfh"};